__turbopack_context__.v({
  "card": "system-health-module__g7LSEG__card",
});
